import { useQuery } from '@tanstack/react-query';

import { libraryApi } from '../api/library.api.js';

export function useReadingByMonth() {
  return useQuery({
    queryKey: ['profile', 'reading-by-month'],
    queryFn: () => libraryApi.getReadingByMonth(),
    staleTime: 5 * 60 * 1000,
  });
}
